<template>
  <div>
    <Header />

    <div class="container-fluid users-container">
      <div class="row">
        <div class="col-md-3 col-sm-12 pr-0 dark-bg">
          <DivvyAdminSidebar />
        </div>

        <transition appear name="fade">
          <div class="col-md-9 right-container">
            <div class="col-md-12 pt-4">
              <h4 class="page-header">
                Users
              </h4>
              <hr />
              <UsersFilters />

              <router-link
                class="btn btn-primary btn-lg btn-sm-block mt-2 mb-4"
                :to="{ name: 'DivvyAdminUsersAddUser' }"
                @click.native="scrollToTop"
              >
                Add User
              </router-link>

              <UsersTable />
              <BonusPoints />
            </div>
          </div>
        </transition>
      </div>
    </div>

    <Footer />
  </div>
</template>

<script>
import Header from "@/components/Header.vue";
import Footer from "@/components/Footer.vue";
import DivvyAdminSidebar from "@/views/divvyadmin/divvyAdminSidebar.vue";
import UsersFilters from "./UsersFilters.vue";
import BonusPoints from "./BonusPoints.vue";
import UsersTable from "./UsersTable.vue";

export default {
  name: "Users",
  components: {
    DivvyAdminSidebar,
    Header,
    Footer,
    UsersFilters,
    UsersTable,
    BonusPoints,
  },

  methods: {
    setActiveMenuItem: function() {
      this.$store.dispatch("divvyAdminSidebar/setActive", {
        activeMenuItem: this.activeMenuItem
          ? this.activeMenuItem
          : "usersmodule",
        activeMenu: this.activeMenu ? this.activeMenu : "clientusermanagement",
      });
    },
  },

  created() {
    this.setActiveMenuItem();
  },
};
</script>

<style lang="scss" scoped>
.users-container {
  min-height: 100%;
  margin: -14px 0 0 0;
}
</style>
